import { ChangeDetectionStrategy, Component, computed, inject, input } from "@angular/core";
import { TypeManagerDecorator } from "../../main/type.map.service";
import { OrgDetailsSection, statusMessagesForSection } from "./se.org.status.service";
import { SeOrgSecurityStore } from "./se.org.security.store";

@TypeManagerDecorator("s25-ng-se-org-section-status-banner")
@Component({
    selector: "s25-ng-se-org-section-status-banner",
    standalone: true,
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [],
    template: `
        @if (messages().length) {
            <div class="org-section-status-banner" role="status">
                @for (message of messages(); track message) {
                    <p>{{ message }}</p>
                }
            </div>
        }
    `,
    styles: `
        .org-section-status-banner {
            background: var(--color--background-info);
            border: 1px solid var(--color--border-info);
            border-radius: 8px;
            padding: 1rem 1.25rem;
            margin-bottom: 1.5rem;
        }

        .org-section-status-banner p {
            margin: 0;
        }

        .org-section-status-banner p + p {
            margin-top: 0.5rem;
        }
    `,
})
export class SeOrgSectionStatusBannerComponent {
    readonly section = input.required<OrgDetailsSection>();

    private readonly orgSecStore = inject(SeOrgSecurityStore);

    readonly messages = computed(() => statusMessagesForSection(this.orgSecStore.statusEffects(), this.section()));
}
